import { gql } from '@/__generated__/gql';

export const GET_SETTINGS_QUERY = gql(`
  query SettingsPageSettings($ids: [String!], $type: String) {
    Settings(ids: $ids, type: $type) {
      id
      key
      description
      type
      value
    }
  }
`);

export const CREATE_SETTING_MUTATION = gql(`
  mutation SettingsPageCreateSetting($data: CreateSettingDto!) {
    createSetting(data: $data) {
      id
      key
    }
  }
`);

export const UPDATE_SETTING_MUTATION = gql(`
  mutation SettingsPageUpdateSetting($data: UpdateSettingDto!) {
    updateSetting(data: $data) {
      id
      key
    }
  }
`);

export const DELETE_SETTING_MUTATION = gql(`
  mutation SettingsPageDeleteSetting($id: String!) {
    deleteSetting(id: $id)
  }
`);

export const SYSTEM_SETTINGS_QUERY = gql(`
  query FatSettingsPageSystemSettings($data: FetchSystemSettingsArgs!) {
    systemSettings(data: $data) {
      id
      key
      value
      type
    }
  }
`);

export const CREATE_TENANT_SETTING_OVERRIDE_MUTATION = gql(`
  mutation FatSettingsPageCreateTenantSettingOverride($data: CreateTenantOverrideDto!) {
    createTenantSettingOverride(data: $data) {
      id
      key
      value
      type
    }
  }
`);

export const CREATE_SYSTEM_SETTING_MUTATION = gql(`
  mutation FatSettingsPageCreateSystemSetting($data: CreateSystemSettingDto!) {
    createSystemSetting(data: $data) {
      id
      key
      value
      type
    }
  }
`);

export const UPDATE_SYSTEM_SETTING_MUTATION = gql(`
  mutation FatSettingsPageUpdateSystemSetting($data: UpdateSystemSettingDto!) {
    updateSystemSetting(data: $data) {
      id
      key
      value
      type
    }
  }
`);

export const UPDATE_DEFAULT_USER_ROLES_MUTATION = gql(`
  mutation FatSettingsPageUpdateDefaultUserRoles($data: UpdateDefaultUserRolesInput!) {
    updateDefaultUserRoles(data: $data) {
      id
    }
  }
`);

export const TENANT_NAME_QUERY = gql(`
  query FatSettingsPageTenant($id: String!) {
    tenant(id: $id) {
      id
      name
    }
  }
`);

export const UPDATE_TENANT_NAME_MUTATION = gql(`
  mutation FatSettingsPageUpdateTenantName($id: String!, $name: String!) {
    updateTenantName(id: $id, name: $name) {
      id
      name
    }
  }
`);

export const GET_ASSET_SIGNED_URL_QUERY = gql(`
  query SettingsPageGetAssetSignedUrl($assetKey: String!) {
    getAssetSignedUrl(assetKey: $assetKey)
  }
`);
